<div id="modal-container" class="app-modal-content">
    <img id="pimg" [src]="imageUrl" class="popup-img" alt="Result icon" />
    <p id="pttl" data-text class="popup-title" contenteditable="true" (keyup)="handleTitleChange($event)">{{ data.title }} </p>
    <div class="control-error title">{{titleError}}</div>
    <p id="ptxt" data-text class="popup-text" contenteditable="true" (keyup)="handleTextChange($event)">{{ data.text }} </p>
    <div class="control-error text">{{textError}}</div>
    <button data-button id="modal-confirm-btn" class="btn btn-popup" (click)="close()" [disabled]="isDisabled()"> OK </button>
</div>